export default __webpack_public_path__ + "static/Card10-ff9440de3b1c901e617acf56f9812af6.png";